import { getExperimentEligibility } from "../../state/modules/featureToggles/selectors";
import activateMvtFeature from "../activateMvtFeature";

const setupOptimizely = async ({ getState }) => {
  const state = getState();
  const experimentEligibility = getExperimentEligibility(state);
  const experimentsToActivate = Object.entries(experimentEligibility).map(
    ([experiment, eligible]) => {
      if (eligible) {
        return activateMvtFeature(experiment);
      }
    }
  );

  await Promise.all(experimentsToActivate);
};

export default setupOptimizely;
